import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-suspended',
  templateUrl: 'account-suspended.component.html',
  styleUrls: ['account-suspended.component.scss'],
})
export class AccountSuspendedComponent implements OnInit {
  ngOnInit() {}
}
